/** Inverse — inverted controls: draw by moving (hover), then click to set the mark. */
import type { CreateModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import type { Point } from '../../core/scene';
import { defaultStyle } from '../../core/scene';
import { buildSmoothPath, distance } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3l6 14 2-5 5-2z"/><path d="M14 14l5 5"/></svg>';

export function createInverseShapes(): CreateModule {
  let pts: Point[] = [];

  return {
    manifest: {
      id: 'inverse',
      kind: 'create',
      name: 'Inverse',
      apiVersion: 1,
      description: 'Inverted controls — draw by moving the mouse with no button, then click to set it. (Pointer/mouse only.)',
      icon: ICON,
      params: [{ kind: 'slider', key: 'weight', label: 'Weight', min: 0.5, max: 24, step: 0.5, default: 2 }],
    },

    onHover(s) {
      const p = { x: s.x, y: s.y };
      const last = pts[pts.length - 1];
      if ((!last || distance(last, p) >= 2) && pts.length < 800) pts.push(p);
    },

    getLiveShapes(ctx) {
      if (pts.length < 2) return [];
      const style = defaultStyle();
      style.color = { ...ctx.ink };
      style.lineWidth = cfgNum(ctx.config, 'weight', 2);
      return [ctx.newShape({ path: buildSmoothPath(pts), style })];
    },

    onCommit() {
      pts = [];
    },

    onClear() {
      pts = [];
    },

    onReselect() {
      pts = [];
    },
  };
}
